import React from "react";
import Hero from "../components/home/Hero";
import About, { Facts } from "../components/home/About";
import Skills from "../components/home/Skills";
import Ventures from "../components/home/Ventures";
import FeaturedWork from "../components/home/FeaturedWork";
import Contact from "../components/home/Contact";

function Home() {
  return (
    <>
      <Hero />
      <Facts />
      <About />
      <Skills />
      <Ventures />
      <FeaturedWork />
      <Contact />
    </>
  );
}

export default Home;
